// Shared service identity for all telemetry (browser events, server spans,
// structured logs) so signals from every runtime join under one service in Dash0.
export const SERVICE_NAME = 'numa-my-trips';
